import { c as _c } from "react/compiler-runtime";
import { Badge, classNames, FlexCenter, FlexColumn, formatAddress, ItemAvatar, ItemContent, ItemSide, ItemTitle, Label, RadioGroup, RadioGroupItem, TextBody, Tooltip } from "@opensea/ui-kit";
import { InfoFilled } from "@opensea/ui-kit/icons";
import { uniqBy } from "es-toolkit/array";
import { useMemo, useRef } from "react";
import { useTranslations } from "use-intl";
import { Item } from "../../../components/Item";
import { CreditCard } from "../../../components/icons/CreditCard";
import { useConnect, useConnectors, useGetPreviouslyConnectedAccountsForConnector } from "../../../polychain/hooks";
import { itemVariants } from "../constants";
const PaymentMethodOptions = t0 => {
  const $ = _c(6);
  const {
    paymentMethod,
    setPaymentMethod,
    children
  } = t0;
  let t1;
  if ($[0] !== setPaymentMethod) {
    t1 = value => setPaymentMethod?.(value);
    $[0] = setPaymentMethod;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== paymentMethod || $[4] !== t1) {
    t2 = <FlexColumn className="gap-3"><RadioGroup className="max-h-[330px] overflow-y-auto" onValueChange={t1} value={paymentMethod}>{children}</RadioGroup></FlexColumn>;
    $[2] = children;
    $[3] = paymentMethod;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
const Card = t0 => {
  const $ = _c(18);
  const {
    selected,
    disabledReason
  } = t0;
  const t = useTranslations("wallet.PaymentMethodOptions");
  const t1 = Boolean(disabledReason);
  let t2;
  if ($[0] !== selected || $[1] !== t1) {
    t2 = classNames(itemVariants({
      interactive: t1
    }), selected && "!bg-bg-additional-2");
    $[0] = selected;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = Boolean(disabledReason);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CreditCard size={24} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t("debitCreditCard");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <ItemContent><ItemTitle>{t5}</ItemTitle></ItemContent>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ItemSide><RadioGroupItem id="payment-method-card" value="card" /></ItemSide>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <Label htmlFor="payment-method-card">{t4}{t6}{t7}</Label>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t8) {
    t9 = <div><Item asChild={true} className={t2} disabled={t3} interactive={true}>{t8}</Item></div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== disabledReason || $[16] !== t9) {
    t10 = <Tooltip content={disabledReason}>{t9}</Tooltip>;
    $[15] = disabledReason;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
const Wallet = t0 => {
  const $ = _c(10);
  const {
    connectorId
  } = t0;
  const t = useTranslations("wallet.PaymentMethodOptions");
  const {
    getConnectorStrict
  } = useConnect();
  const connector = getConnectorStrict(connectorId);
  const getPreviouslyConnectedAccounts = useGetPreviouslyConnectedAccountsForConnector();
  const previouslyConnectedAccounts = getPreviouslyConnectedAccounts(connectorId);
  const hasPreviouslyConnected = previouslyConnectedAccounts.length > 0;
  const paymentMethod = `wallet-${connector.id}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(itemVariants());
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const T0 = ItemSide;
  const t2 = "overflow-visible";
  const T1 = FlexCenter;
  const t3 = "gap-2";
  const t4 = connector.isConnected() ? <Badge icon={InfoFilled}>{t("connected")}</Badge> : connector.isInstalled ? <Badge icon={InfoFilled}>{t("installed")}</Badge> : hasPreviouslyConnected ? <Badge icon={InfoFilled}>{t("usedPreviously")}</Badge> : null;
  let t5;
  if ($[1] !== paymentMethod) {
    t5 = <RadioGroupItem id={paymentMethod} value={paymentMethod} />;
    $[1] = paymentMethod;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== T1 || $[4] !== t4 || $[5] !== t5) {
    t6 = <T1 className={t3}>{t4}{t5}</T1>;
    $[3] = T1;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== T0 || $[8] !== t6) {
    t7 = <T0 className={t2}>{t6}</T0>;
    $[7] = T0;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return <Item asChild={true} className={t1} data-testid={`wallet-${connector.id}`} interactive={true} key={connector.id}><Label htmlFor={paymentMethod}>{connector.icon ? <ItemAvatar aria-hidden={true} src={connector.icon} /> : null}<ItemContent><ItemTitle>{connector.name}{hasPreviouslyConnected ? <>{" "}<TextBody color="text-secondary" weight="regular">{formatAddress(previouslyConnectedAccounts[0].address)}</TextBody></> : null}</ItemTitle></ItemContent>{t7}</Label></Item>;
};
const WalletOptions = t0 => {
  const $ = _c(7);
  const {
    selectedPaymentMethod
  } = t0;
  const {
    connectors
  } = useOrderedConnectors();
  let t1;
  if ($[0] !== connectors || $[1] !== selectedPaymentMethod) {
    const uniqueConnectors = uniqBy(connectors, _temp);
    let t2;
    if ($[3] !== selectedPaymentMethod) {
      t2 = connector => <Wallet connectorId={connector.id} key={connector.id} selectedPaymentMethod={selectedPaymentMethod} />;
      $[3] = selectedPaymentMethod;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = uniqueConnectors.map(t2);
    $[0] = connectors;
    $[1] = selectedPaymentMethod;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function useOrderedConnectors() {
  const {
    connectors,
    activeConnector,
    ...rest
  } = useConnectors();

  // Put active connector first and keep it first even if active connector changes
  const initialActiveConnectorId = useRef(activeConnector?.id);
  const orderedConnectors = useMemo(() => {
    if (!initialActiveConnectorId.current) {
      return connectors;
    }
    const result = [];
    const initialActiveConnector = connectors.find(c => c.id === initialActiveConnectorId.current);
    if (initialActiveConnector) {
      result.push(initialActiveConnector);
    }
    result.push(...connectors.filter(c_0 => c_0.id !== initialActiveConnector?.id));
    return result;
  }, [connectors]);
  return {
    connectors: orderedConnectors,
    activeConnector,
    ...rest
  };
}
export { PaymentMethodOptions, Card as PaymentMethodOptionsCard, Wallet as PaymentMethodOptionsWallet, WalletOptions as PaymentMethodOptionsWalletOptions };
function _temp(c) {
  return c.name;
}